import { Brick, BrickContext, registerBrick, GlobalProperties } from 'olympe';

export default class SetRoute extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} route
     * @param {function()} forwardEvent
     */
    update($, [route], [forwardEvent]) {
        // Do not do anything while in Draw.
        if (!$.get(GlobalProperties.EDITION, true)) {
            window.location.hash = route.startsWith('/') ? route : `/${route}`;
            forwardEvent();
        }
    }
}

registerBrick('01880ffc9ea23402e480', SetRoute);
